/** @jsxImportSource @emotion/react */

import React from 'react';
import { theme } from 'styles/theme/theme';

interface IProps extends React.SVGProps<SVGSVGElement> {
  width?: number;
  height?: number;
}

function VkVideoIcon(props: IProps) {
  const { width = 36, height = 36, ...rest } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <rect x="9.83301" y="4" width="22.1668" height="28" rx="6" fill={theme.colors.Gray} />
      <rect x="4" y="4" width="24.5001" height="28" rx="6" fill={theme.colors.WhiteGray} />
      <path
        d="M19.8198 17.3506C20.3198 17.6393 20.3198 18.3617 19.8198 18.6504L14.1528 21.9219C13.653 22.2102 13.0281 21.8495 13.0278 21.2725V14.7285C13.028 14.1514 13.653 13.7908 14.1528 14.0791L19.8198 17.3506Z"
        stroke="white"
        strokeWidth="2.5"
      />
    </svg>
  );
}

export default VkVideoIcon;
